export enum TooltipBehaviour {
  click = 'click',
  hover = 'hover',
  none = 'none',
}
